// removed by extract-text-webpack-plugin
module.exports = {"Section":"layout__Section__2xrxZ","Anesthesia":"layout__Anesthesia__2tZZZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/layout.css
// module id = 2
// module chunks = 0